
<div class="info-view-container d-flex align-items-center">
  <p class="text-center w-100">
      <span class="px-2">LON: <span class="fw-bold">{{mapService.mouseCoordinates[0] | number: '2.' + decimalPlaces}}</span> </span>
      <span class="px-2">LAT: <span class="fw-bold">{{mapService.mouseCoordinates[1] | number: '2.' + decimalPlaces}}</span> </span>
      <!-- <span>{{ 'map.control_info_view.scale' | translate }}: </span> <span class="fw-bold">{{mapRatioScale(mapService.mapResolution)}}</span> -->
  </p>
  <button
    mat-icon-button
    type="button"
    class="capture-button"
    [class.active]="isCapturing"
    [matTooltip]="'map.control_info_view.capture_coordinates' | translate"
    [attr.aria-label]="'map.control_info_view.capture_coordinates' | translate"
    [attr.aria-pressed]="isCapturing"
    (click)="toggleCapture()"
  >
    <mat-icon>gps_fixed</mat-icon>
  </button>
</div>
